<template>
<div class="row">
  <div class="Absolute-Center is-Responsive">
    <div id="logo-container"></div>
    <div v-if="isHidden" class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div v-if="isHidden">Logging you in... Please Wait</div>
    <div v-if="!isHidden" class="col-sm-12">
      <div class="form-group col-md-12">
        <input type="email" class="form-control" id="app-email-address" aria-describedby="emailHelp" placeholder="Email" v-model="body.email">
      </div>
      <div class="form-group col-md-12">
        <input type="password" @keyup.enter="login" class="form-control" id="exampleInputPassword1" placeholder="Password" v-model="body.password">
      </div>
      <button class="btn btn-primary btn-block" @click="login" v-on:click="isHidden = true">Login</button> 
      <br>
      <button class="btn btn-primary btn-block" @click="signup">Sign Up</button> 
      <br>
      <button class="btn btn-primary btn-block" @click="resetPassword">Reset Password</button> 
    </div>  
  </div>    
</div>
</template>

<script>
import api from '../services/api'
import { Login } from '../models/login'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      body: Login,
      isHidden: false
    }
  },
  methods: {
    ...mapActions(['appLogin']),
    async login() {
      const loginApi = api('login')
      const data = await loginApi.login(this.body)
      this.appLogin(data)
      this.$router.push({ name: 'dashboard' })
    },
    signup() {
      this.$router.push({ name: 'signUp' })
    },
    resetPassword() {
      this.$router.push({ name: 'requestResetPassword' })
    },
  }
}
</script>